import React, { useMemo } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import Util from '../Util';
import Detail from './Detail';
import S from './CardStyle.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LocatorInfoCard(props) {
  const {
    locator,
    locatorSalesPrice
  } = props;
  const locatorOffline = Util.isLocatorOffline(locator);
  const locatorLowBattery = Util.isLocatorLowBattery(locator);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "dashboardCard",
    className: S.container,
    children: [/*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "keysDataCardUpper",
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          width: 80,
          height: 80,
          alt: "RecovR Locator",
          src: "https://storage.googleapis.com/recovr-ui-assets/recovr-locator.png"
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: "The RecovR Locator is included in this sale."
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodySmall",
            children: "It offers vehicle location tracking, theft recovery assistance, and movement alerts."
          })]
        })]
      }), locatorSalesPrice != null && /*#__PURE__*/_jsx(Detail, {
        label: "RecovR Locator Sales Price",
        value: `$${locatorSalesPrice}`
      })]
    }), /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "keysDataCardLower",
      children: [/*#__PURE__*/_jsx(Detail, {
        label: "Locator ID",
        value: Attributes.get('locator.serialNumber', 'locator', locator)
      }), locatorLowBattery && /*#__PURE__*/_jsx(Text, {
        variant: "pairingSuggestionSubtitle",
        children: "Locator battery is below the 70% threshold recommended for sale. Replacement required."
      }), locatorOffline && /*#__PURE__*/_jsx(Text, {
        variant: "pairingSuggestionSubtitle",
        children: "Locator Offline. Replacement required."
      })]
    })]
  });
}